module.exports = __webpack_public_path__ + "static/media/studentBlueIcon.4aa95ae4.png";